import {
    enrichAnalyticsUser,
    mapMarketingParameters,
    sendAnalyticsEvent,
} from '@devsbb/analytics-client';
import CookiesManager from 'ggApp/utils/CookiesManager';

const SESSION_COOKIE_KEY = '__campaign_session_cookie__';

export const trackAdCampaignAnalytics = (): void => {
    const cookiesManager: any = new CookiesManager();
    // Send ad campaign analytics only once per 30 minute session
    if (cookiesManager.get(SESSION_COOKIE_KEY) === 'true') {
        return;
    }
    cookiesManager.set(SESSION_COOKIE_KEY, 'true', { maxAge: 30 * 60 }); // convert 30 minutes in seconds

    const traits = mapMarketingParameters(window.location.href, document.referrer);
    if (traits === null) return;
    enrichAnalyticsUser({ ...traits });
    sendAnalyticsEvent('Session Started', {}, { segment: { traits } });
};
